import classNames from 'classnames'
import { CircularCheckbox } from 'components/CircularCheckbox'
import React, { PropsWithChildren } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { SubtitleColorType } from 'service/list'
import { FormValues } from 'utils/type'

interface SubtitleFontProps {
  subtitleFontList: SubtitleColorType[] | []
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
}
export const SubtitleFont = ({
  subtitleFontList,
  watch,
  setValue,
  control,
}: PropsWithChildren<SubtitleFontProps>) => {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-[18px] text-left">폰트</p>
      <div className="grid grid-cols-2 md:grid-cols-4  gap-x-1 gap-y-[16px] ">
        {subtitleFontList?.map((subtitleFont, index) => {
          return (
            <>
              <div
                className={classNames(
                  'flex items-center gap-1 cursor-pointer rounded-[6px] px-2 py-[15px]',
                  {
                    'bg-[#2E343D]': watch('subtitleFontId') !== subtitleFont.id,
                    'bg-main': watch('subtitleFontId') === subtitleFont.id,
                  }
                )}
                key={`subtitle_font_${index}`}
                onClick={() => {
                  setValue('subtitleFontId', subtitleFont.id)
                }}
              >
                <Controller
                  render={({ field }) => (
                    <CircularCheckbox
                      {...field}
                      id={index}
                      checked={watch('subtitleFontId') === subtitleFont.id}
                      onChange={() => {}}
                    />
                  )}
                  name="subtitleFontId"
                  control={control}
                />
                <img
                  src={subtitleFont?.imagePath}
                  alt=""
                  className={`subtitle-${index}`}
                />
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}
